import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.jsx';
import './index.css';

// This marketing site is its own Firebase Hosting site/target (see
// firebase.json), separate from the application's — so every route
// (/advertisers, /billboard, ...) can have a real SPA catch-all rewrite to
// this bundle's index.html, and BrowserRouter gives clean, indexable URLs
// instead of a #/ prefix.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);
